import React from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export function Root() {
  return <p className='text-2xl font-medium'>Tokoevent CRA WIP</p>;
}

export interface FormatCurrencyProps
  extends React.HTMLAttributes<HTMLDivElement> {
  amount: number;
  currency?: string;
}

export const FormatCurrency: React.FC<FormatCurrencyProps> = ({
  currency = 'IDR',
  amount,
}) => {
  return (
    <>
      {new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
      })
        .format(amount)
        .replace('IDR', 'Rp')}
    </>
  );
};

export default function ExternalRedirect() {
  const { id } = useParams();

  useEffect(() => {
    window.location.href = `https://tokoevent.com/tickets/${id}`;
  }, [id]);

  return <p>Redirecting...</p>;
}
